import { ComponentsOverrides, Theme } from '@mui/material';

import { muiPalette } from '@/shared/general-theme';

export const TableStyles = (palette: typeof muiPalette): ComponentsOverrides<Theme>['MuiTable'] =>
  (
    {
      root: {
        color: palette.text.primary,
      },
    }
  );

export const RowStyles = (palette: typeof muiPalette): ComponentsOverrides<Theme>['MuiTableRow'] =>
  (
    {
      root: {
        '&:hover': {
          backgroundColor: palette.action.hover,
        },
        '&.Mui-disabled': {
          backgroundColor: palette.action.disabledBackground,
          opacity: 0.6,
        },
      },
      head: {
        '&:hover': {
          backgroundColor: 'initial',
        },
      },
    }
  );

export const CellStyles = (palette: typeof muiPalette): ComponentsOverrides<Theme>['MuiTableCell'] =>
  (
    {
      root: {
        cursor: 'default',
        padding: '1rem',
      },
      head: {
        backgroundColor: palette.grey[100],
        color: palette.grey[600],
        fontWeight: 600,
        fontSize: '0.75rem',
        borderBottom: `1px solid ${palette.divider}`,
      },
    }
  );

export const PaginationStyles = (palette: typeof muiPalette): ComponentsOverrides<Theme>['MuiTablePagination'] =>
  (
    {
      root: {
        borderTop: `1px solid ${palette.divider}`,
        color: palette.grey[600],
        backgroundColor: palette.grey[100],
        cursor: 'default',
      },
      input: {
        backgroundColor: palette.grey[100],
        marginLeft: 'initial',
        cursor: 'default',
        marginRight: '0.5rem !important',
      },
      selectLabel: {
        fontSize: '0.75rem',
      },
      select: {
        paddingRight: '2rem !important',
        paddingLeft: '0.5rem !important',
      },
      selectIcon: {
        right: '0.5rem',
      },
      actions: {
        marginLeft: '0.5rem',
      },
      toolbar: {
        paddingLeft: '2rem !important',
        paddingRight: '0.125rem !important',
      },
      displayedRows: {
        fontSize: '0.75rem',
      },
    }
  );